import React from 'react';
import { Algorithm } from '../../interfaces/algorithm';
import { DefaultValues, SubmitHandler } from 'react-hook-form';
import { FakeLink } from '../../components/styled/styles';
import { ControlledFileUpload, ControlledInput, GridFormElement } from '../form-controls';
import { Grid } from '@material-ui/core';
import { Divider, Button } from '@dls/react-core';
import { useFormWithServerErrorHandling } from '../../helpers/form-error-handling';

export type AlgorithmFormFields = Omit<Algorithm, 'id' | 'versions'> & { privateKey: any[] };

interface AlgorithmFormProps {
  algorithm?: DefaultValues<AlgorithmFormFields>;
  onSubmit: SubmitHandler<AlgorithmFormFields>;
  onCancel: () => void;
  submitButtonText?: string;
  cancelButtonText?: string;
}

export const AlgorithmForm: React.FC<AlgorithmFormProps> = ({
  algorithm,
  onSubmit,
  submitButtonText,
  onCancel,
  cancelButtonText,
}) => {
  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useFormWithServerErrorHandling<AlgorithmFormFields>({
    defaultValues: algorithm,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3} direction="column" style={{ padding: '16px 24px 0px' }}>
        <GridFormElement label="Name">
          <ControlledInput
            control={control}
            name="name"
            rules={{ required: 'Name is required', minLength: 1 }}
            inputProps={{ fullWidth: true, placeholder: 'Enter algorithm name' }}
          />
        </GridFormElement>

        <GridFormElement label="Repository">
          <ControlledInput
            control={control}
            name="repository"
            rules={{
              required: 'Repository is required',
              minLength: 1,
              pattern: {
                value: /git@github.com:.*\/.*\.git/,
                message: 'Repository should be of format: git@github.com:<owner>/<repo>.git',
              },
            }}
            inputProps={{ fullWidth: true, placeholder: 'Enter repository url' }}
          />
        </GridFormElement>

        <GridFormElement label="Private Key">
          <ControlledFileUpload
            control={control}
            name="privateKey"
            rules={{ required: 'Private key is required' }}
            fileUploadProps={{
              type: 'default', //By default type is dropzone
              text: 'Add file', //optional. By default Add files will be displayed for the button
              maxFilesize: 10485760, //10MB max file size
              maxCharsize: 40, //optional. Default length of the file name displayed to show ellipsis is 30
              accept: '',
            }}
          />
        </GridFormElement>
        <Divider className={'DLS-divider-in-list'} style={{ marginTop: '32px' }} />
        <div
          style={{
            display: 'flex',
            padding: '16px 24px',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <FakeLink className={'noUnderLineLink'} onClick={onCancel}>
            {cancelButtonText || 'Cancel'}
          </FakeLink>
          <Button dls_variant="primary" type="submit" disabled={isSubmitting}>
            {submitButtonText || 'Submit'}
          </Button>
        </div>
      </Grid>
    </form>
  );
};
